import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { vdomain } from "commons/config";
import { monetize } from "commons/utils";
import { langContext } from "commons/contexts";

import style from "./style.module.scss";

interface props {
    data: Record<string, any>;
    refNo: string;
    imageCache: { [key: string]: any };
}
function Item({ data, refNo, imageCache }: props) {

    const history = useHistory();
    const { lang } = useContext(langContext);

    useEffect(() => {
        async function loadCoverImage() {
            var response = await fetch(vdomain + "/int-getFiles", { method: "POST", body: JSON.stringify({ ref: (refNo + ""), cover: true, type: "slideshow" }) });
            var data = (await response.json())[0];
            data = data ? data : "";


            if (!imageCache?.images.result[refNo]) {
                var images = { ...imageCache.images };
                images.result[refNo] = data;

                imageCache.setImages(images);
            }
        }

        loadCoverImage();

    //eslint-disable-next-line
    }, []);


    return (
        <div className={style.root} onClick={e => {
            history.push("/" + lang + `/show?ref=${refNo}`);
        }}>
            <div className={style.image} style={{ backgroundImage: `url("${imageCache?.images?.result?.[refNo]}")` }} />

            <div className={style.descriptionCnt}>
                <div className={style.description}>
                    <div className={style.innerFrame}>
                        <div className={style.topTitle}>
                            {data?.region || ""}
                        </div>
                        <div className={style.mainTitle}>
                            {data?.location || ""}
                        </div>
                        <div className={style.line} />
                        <div className={style.price}>
                            {monetize(data?.price)}
                        </div>
                        <div className={style.details}>
                            {`${refNo || ""} · ${data?.type || ""} · ${data.bedrooms || ""} bedrooms`}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Item;